<template>
	<div class="container">
		<div class="one">
			<div class="shuru">
				<div class="shuru1">
					<span>输入预估分数:</span><input type="text" placeholder="输入预估分数" />
				</div>
				<div class="shuru2">
					<span>意向专业类别:</span><input type="text" placeholder="意向专业类别" />
				</div>
			</div>
			<div class="schoolWZ" v-for="(item,index) in crumbs" :key="index+1">
				<div class="SCLeft">
					<span>{{item.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator="">
						<!--  -->
						<el-breadcrumb-item v-for="(item1,index2) in item.Cont" :key="index2+2"><a @click="isT(index2)"
								:class=" isTrue == index2 ? 'active' :''">{{item1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<!-- <div class="em"></div> -->
			<div class="schoolWZ" v-for="(itemA,index3) in crumbs1" :key="index3+3">
				<div class="SCLeft">
					<span>{{itemA.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator="">
						<el-breadcrumb-item v-for="(itemA1,index4) in itemA.Cont" :key="index4+4"><a
								@click="isT1(index4)" :class=" isTrue1 == index4 ? 'active' :''">{{itemA1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<!-- <div class="em1"></div> -->
			<div class="schoolWZ" v-for="(itemB,index5) in crumbs2" :key="index5+5">
				<div class="SCLeft">
					<span>{{itemB.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator="">
						<el-breadcrumb-item v-for="(itemB1,index6) in itemB.Cont" :key="index6+6"><a
								@click="isT2(index6)" :class=" isTrue2 == index6 ? 'active' :''">{{itemB1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "",
		components: {

		},
		data() {
			return {
				isTrue: 0,
				isTrue1: 0,
				isTrue2: 0,
				isTrue3: 0,
				// 面包屑渲染
				crumbs: [{
					title: '专业类型：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '本科'
						},
						{
							cont1: '专科'
						},
					]
				}],
				crumbs1: [{
					title: '专业类别：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '资源环境与安全'
						},
						{
							cont1: '能源动力与材料'
						},
						{
							cont1: '土木建筑'
						},
						{
							cont1: '水利'
						},
						{
							cont1: '装备制造'
						},
						{
							cont1: '生物与化工'
						},
						{
							cont1: '轻工纺织'
						},
						{
							cont1: '食品药品与粮食'
						},
						{
							cont1: '交通运输'
						},
						{
							cont1: '电子信息'
						},
						{
							cont1: '医药卫生'
						},
						{
							cont1: '财经商贸'
						},
						{
							cont1: '旅游'
						},
						{
							cont1: '医学'
						},
						{
							cont1: '文化艺术'
						},
						{
							cont1: '新闻传播'
						},
						{
							cont1: '教育与体育'
						},
						{
							cont1: '公司与安法'
						},
						{
							cont1: '公共管理与服务'
						},
						{
							cont1: '农林牧渔'
						},

					]
				}],
				crumbs2: [{
					title: '专业大类：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '农业类'
						},
						{
							cont1: '林业类'
						},
						{
							cont1: '畜牧业类'
						},
						{
							cont1: '渔业类'
						},
						{
							cont1: '畜牧兽医类'
						},
						{
							cont1: '水产养殖类'
						}
					]
				}],
			}
		},
		methods: {
			isT(index) {
				this.isTrue = index;
			},
			isT1(index) {
				this.isTrue1 = index;
			},
			isT2(index) {
				this.isTrue2 = index;
			},
		}


	}
</script>

<style scoped>
	.shuru input {
		font-size: 16px;
		width: 320px;
		height: 40px;
		background: rgb(255, 255, 255);
		border: 1px solid #E0E0E0;
		opacity: 1;
		border-radius: 5px;
		padding: 0 10px;
		box-sizing: border-box;
	}
	
	.shuru span {
		font-size: 18px;
		font-weight: 500;
		line-height: 37px;
		color: #333333;
		opacity: 1;
	}
	
	.shuru {
		display: flex;
		justify-content: space-evenly;
		margin-bottom: 15px;
	}
	
	.one {
		margin-top: 20px;
		justify-content: space-around;
		width: 100%;
		background: rgba(255, 255, 255, 0.39);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
		opacity: 1;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		padding: 20px;

	}

	.el-breadcrumb {}

	.one span {
		line-height: 50px;
		margin-right: 8px;
	}

	.schoolWZ {
		width: 100%;
		height: auto;
		display: flex;
	}


	.schoolWZ .SCLeft {
		width: 115px;
	}

	.schoolWZ .SCmain {
		width: 64px;
		height: 60px;
		margin-right: 15px;
		margin-top: 10px;

	}

	.schoolWZ .SCmain a {
		display: block;
		text-align: center;
		line-height: 32px;
		font-weight: 600;
		height: 32px;
		color: #333333;
		opacity: 1;
		cursor: pointer;
		font-size: 14px;
		margin: 0 10px;
	}

	.active {
		background: #e63233;
		color: #fff !important;
		border-radius: 16px;
		padding: 6px 11px;
		box-sizing: border-box;
	}

	.schoolWZ .SCbottom {
		width: 100%;
		text-align: left;
		padding-bottom: 10px;
		border-bottom: 1px #eee9e9 solid;
	}

	.schoolWZ:nth-of-type(4) .SCbottom {
		padding-bottom: 10px;
		border-bottom: none;
	}

	.schoolWZ .SCbottom a {
		text-decoration: none;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 600;
		line-height: 20px;
		color: #333333;
		opacity: 1;
	}

	/* 设置个别宽度不是以下不是此范围的样式 */
	@media (min-width: 1400px) {
		.container {
			width: 1500px;
		}
	}

	/* .em {
		width: 1140px;
		height: 1px;
		margin-left: 33px;
		margin-top: 30px;
		margin-bottom: 30px;
		
	}
	
	.em1 {
		width: 1140px;
		height: 1px;
		margin-left: 93px;
		margin-bottom: 10px;
		border-bottom: 1px #eee9e9 solid;
	} */

	@media (max-width: 750px) {
		body {
			width: 100%;
			height: auto;
		}
		.shuru {
			display: block;
		}

		/* .em {
			width: 100%;
			margin-left: 0;
		}
	
		.em1 {
			width: 100%;
			margin-left: 0;
		} */

		.schoolWZ .SCLeft {
			width: 134px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/saixuantop2.vue